import { Component, inject, ViewChild } from '@angular/core';
import { MatStepper } from '@angular/material/stepper'; // TODO: TIM: Since we are moving the application away from material UI, we should find a replacement for MatStepper
import { ActivatedRoute, Router } from '@angular/router';
import { RequestOtpComponent } from './pages/request-otp/request-otp.component';
import { SubmitOtpComponent } from './pages/submit-otp/submit-otp.component';
import { RegisterEmailComponent } from './pages/register-email/register-email.component';
import { UserRegistration } from './pages/user-profile/model/model.userProfileForm';
import { Store } from '@ngrx/store';
import { getAssociatedLocale, getSupportedLocale } from 'src/app/config/app-config';
import { QueryParams, SetQueryParams } from 'src/app/store/query-params';
import { Observable } from 'rxjs';
import { cmsCountryDetails, hasError, isServerDown, serviceOptionsState } from 'src/app/store/service-options';
import { CmsCountryObj, Labels, LanguageConfig } from 'src/app/app.models';
import { getCurrentLabelsJson } from 'src/app/store/labels';
import { isStatesResolved } from 'src/app/store/states';
import { countriesInfo } from 'src/app/store/countries';
import { SignInService } from 'src/app/services/sign-in.service';
import { FirebaseService } from 'src/app/services/firebase.service';
import { createInternationalPhoneNumber } from './utils/phone-utils';
import { Auth } from '@angular/fire/auth';
import { RecaptchaVerifier } from 'firebase/auth';
import { WindowService } from 'src/app/services/window.service';
import { EnvService } from 'src/app/services/env.service';
import { ErrorService } from 'src/app/services/error.service';
import { UserPhoneDetails } from 'src/app/models/sign-in.models';
import { LoadingService } from 'src/app/services/loading.service';


interface DecodedJWT {
  client_domain: string
  exp: number
  iat: number 
  iss: string 
  jti: string
  sub: string
  client_name?: string
}

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent {
  @ViewChild('stepper', { static: false }) public stepper: MatStepper;
  @ViewChild('requestOtpComponent') public requestOtpComponent: RequestOtpComponent;
  @ViewChild('submitOtpComponent') public submitOtpComponent: SubmitOtpComponent;
  @ViewChild('registerEmailComponent') public registerEmailComponent: RegisterEmailComponent;

  public flow: 'login' | 'register' | null | string = null; // TODO: Tim: fix typing
  private steps: { [id: string]: number } = {
    loginRegister: 0,
    requestOtp: 1,
    submitOtp: 2,
    registerEmail: 3,
    userProfile: 4
  };
  // Todo: Tim: check if all these fields are actually used
  private languageLocale: string;
  private transactionType: string;
  private jwtToken: string;
  private endpointVersion: string;

  public showFlashPage: boolean = false;
  public languageList: LanguageConfig[] = [];
  public serviceOptionsCmsMappingCountries: CmsCountryObj;
  private userWalletId: string = '';
  public userDialCode: string;
  public userPhoneIso2Code: string;
  public userPhoneNumber: string;
  public userInternationPhoneNumber: string = '';
  public userEmail: string = '';
  private userAuthToken: string = 'TODO:'; // Todo: Tim: remove default value, should default to empty string
  private hasExistingProfile: boolean = false;
  private otpConfirmationResult: any = null;
  public cmsLabels: Labels; // TODO: Tim: Fix types

  public hasError$: Observable<boolean> | undefined; // TODO: tim: is this used??
  public isServerDown$: Observable<boolean> | undefined; // TODO: tim: is this used??
  private serviceOptions$: Observable<any> | undefined; // TODO: Tim: fix type
  public cmsLabels$: Observable<any>; // TODO: Tim: fix typing
  public countries$:  Observable<any[]> | undefined;
  public isStatesResolved$: Observable<boolean> | undefined;

  private windowRef: any; // Todo: Tim: fix type
  public isRecaptchaSolved: boolean = false; // TODO: tim: is this used??
  private recaptchaToken: string; // TODO: tim: is this used??
  public isSignInEnabled: boolean = false; // Todo: Tim: Default to false for #feb11
  private isFirebaseEnabled: boolean = false;
  public isRegressionEnv: boolean = false;

  private auth = inject(Auth);

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store: Store<any>,
    private firebaseService: FirebaseService,
    private signInService: SignInService,
    private envService: EnvService,
    // public auth: Auth,
    private win: WindowService,
    private errorService: ErrorService,
    private loadingService: LoadingService
  ) {
    // this.showFlashPage = displayFlashPage;
  }

  ngOnInit() {
    this.serviceOptions$ = this.store.select(serviceOptionsState);
    this.serviceOptions$.subscribe((serviceOptions) => {
      // console.log('serviceOptions', serviceOptions); // Todo: remove:
      if (serviceOptions.features) {
        this.isSignInEnabled = serviceOptions.features?.isSignInEnabled ?? false;
        this.isFirebaseEnabled = serviceOptions.features?.isFirebaseEnabled ?? false;
        // this.isFirebaseEnabled = true // TODO: remove: #feb11 mock param
        if (this.isSignInEnabled === false) {
          this.router.navigate(['/'], { queryParamsHandling: 'preserve' });
        }
      }
      this.languageList = serviceOptions?.uiConfigs[0]?.languageList || [];
      this.showFlashPage = serviceOptions?.uiConfigs[0]?.displayFashPage || false;
    })
    this.store.select(cmsCountryDetails).subscribe((countries) => {
      this.serviceOptionsCmsMappingCountries = countries;
    });

    // TODO: tim: hasError subscribe and use
    this.hasError$ = this.store.select(hasError);
    // TODO: tim: isServerDown check
    this.isServerDown$ = this.store.select(isServerDown);

    // TODO: tim: indicativeRateCountry check, do we need this for sign-in??

    this.isStatesResolved$ = this.store.select(isStatesResolved); // TODO: tim: is this just for GoogleTagManager??
 
    this.countries$ = this.store.select(countriesInfo);

    this.cmsLabels$ = this.store.select(getCurrentLabelsJson);
    this.cmsLabels$.subscribe((labels) => {
      this.cmsLabels = labels.labels;
      // console.log(this.cmsLabels); // Todo: Remove:
    })
    // // this.labels$.subscribe((labels) => { // TODO: Tim: add Google Tag manager to this

    this.route.queryParams.subscribe((params: any) => { // Todo: Tim: Fix type
      // Todo: Tim: check v3 process, see if any of these variable need a default value
      this.jwtToken = params['token'];
      this.endpointVersion = this.isClientNameInJWT(this.jwtToken) ? 'v3' : 'v2'; 
      this.languageLocale = params['lang'] && params['lang'].length === 2
        ? getAssociatedLocale(params['lang'])
        : getSupportedLocale(params['lang']);
      this.transactionType = params['operation'];

      // DecodeJWT to get walletID
      this.userWalletId = this.getWalletIDFromJWT(this.jwtToken);

      const queryParamsPayload: QueryParams = {
        token: this.jwtToken,
        locale: this.languageLocale,
        operation: this.transactionType
      }

      this.store.dispatch(SetQueryParams({
        queryParams: { queryParams: queryParamsPayload}, 
        endpoint: this.endpointVersion
      }))

      this.isRegressionEnv = this.envService.getEnv().toLowerCase() === 'q1' ? true : false; // Todo: Tim: #feb11 revert to q1
      // this.isRegressionEnv = true; // Todo: Tim: #feb11 Remove: this hardcoded value

      // console.log('setting up windowRef'); // Todo: remove:
      // this.windowRef = this.win.windowRef;
    })
  }

  private async initializeRecaptcha(): Promise<void> {
    // console.log('initialize Recaptcha is running...'); // Todo: remove:
    // console.log('initialize Recaptcha - this.auth', JSON.stringify(this.auth)); // Todo: remove:
    this.loadingService.isLoading.next(true);
    this.windowRef = this.win.windowRef;
    this.windowRef.recaptchaVerifier = new RecaptchaVerifier(this.auth, 'recaptcha-container', {
      'size': 'invisible',
      'callback': (response: any) => {
        console.log('RECAPTCHA IS SOLVED', response); // TODO: remove:
        this.isRecaptchaSolved = true;
      },
      // 'expired-callback': () => { // Todo: Tim: Turn on if a visible recaptcha is used
      //   // Response expired. Ask user to solve reCAPTCHA again.
      //   // Todo: Tim: add logic to reset recaptcha
      //   this.isRecaptchaSolved = false;
      // }
    }); // Todo: Tim: #recaptcha - for q1 regression, should this not initialize with an auth instance?
    this.loadingService.isLoading.next(false);
  }

  public async handleLoginRegister(flowType: string): Promise<void> {
    this.flow = flowType;

    if (!this.windowRef?.recaptchaVerifier && !this.isRegressionEnv && this.isFirebaseEnabled) {
      await this.initializeRecaptcha();
    }

    try {
      const response = await this.signInService.getPhoneByWallet(this.userWalletId);
      // console.log('getPhoneByWallet response:', response); // TOdo: remove:
      const phoneNumber = response.consumer?.mobilePhone?.number ?? null;
      const dialCode = response.consumer?.mobilePhone?.countryDialCode ?? null;
      if (this.flow === 'login' && !!phoneNumber && !!dialCode) {
        this.userInternationPhoneNumber = createInternationalPhoneNumber(dialCode, phoneNumber);
        const userPhoneDetails = {
          phoneNumber: phoneNumber,
          countryDialCode: dialCode,
          internationalPhoneNumber: this.userInternationPhoneNumber
        }
        this.handleRequestOTPEvent(userPhoneDetails);
      }
      else if (this.flow === 'register' && !!phoneNumber && !!dialCode) {
        this.errorService.open('_There is already an account associated with this Wallet. Please select Log In', this.cmsLabels.stellar.dismiss); // Todo: #CMS
      }
      else {
        this.stepper.selectedIndex = this.steps['requestOtp'];
      }
    } catch (error) {
      console.error('error during handleLoginRegister - getPhoneByWallet', error);
      this.errorService.open(this.cmsLabels.stellar.error.somethingHasGoneWrong, this.cmsLabels.stellar.dismiss); // Todo: #CMS
    }
  }

  public updateSignInFlow(flowType: string): void {
    this.flow = flowType;
  }

  public navigateToTransactionFlow(): void {
    this.router.navigate(['/'], { queryParamsHandling: 'preserve' });
  }

  public async handleRequestOTPEvent(userPhoneDetails: UserPhoneDetails): Promise<void> {
    const {phoneNumber, countryDialCode, internationalPhoneNumber} = userPhoneDetails;
    this.userPhoneNumber = phoneNumber;
    this.userDialCode = countryDialCode;
    this.userInternationPhoneNumber = internationalPhoneNumber;
    // console.log('this.userPhoneNumber', this.userPhoneNumber); // Todo: Remove:
    // console.log('internationalPhoneNumber', internationalPhoneNumber); // Todo: Remove:
    if (internationalPhoneNumber === null || !this.userPhoneNumber || !this.userDialCode) {
      console.error('intlPhone is null/invalid');
      return;
    }
    try {
      const response = await this.signInService.checkDigitalProfile(phoneNumber, countryDialCode);
      this.hasExistingProfile = response.profileExists ?? false;
      if (this.hasExistingProfile && this.flow === 'register') {
        this.flow = 'login';
      }
      this.requestOtp(internationalPhoneNumber);
    } catch (error) {
      console.error('error during checkDigitalProfile', error);
      this.errorService.open(this.cmsLabels.stellar.error.somethingHasGoneWrong, this.cmsLabels.stellar.dismiss); // Todo: #CMS
    } 
  }

  private async requestOtp(intlPhone: string) {
    // Todo: Tim: #Q1 regression. We should not use Firebase in Q1
    if (!this.isRegressionEnv && this.isFirebaseEnabled) {
      this.loadingService.isLoading.next(true)
      this.recaptchaToken = await this.windowRef.recaptchaVerifier.verify();
      this.loadingService.isLoading.next(false)
      console.log('recaptchaToken', this.recaptchaToken); // Todo: remove:
    }
    try {
      // For q1 regression, we do not want to actually call the real firebase service. We will return a mocked response instead
      if (this.isRegressionEnv || !this.isFirebaseEnabled) {
        this.otpConfirmationResult = await this.firebaseService.loginWithPhone(intlPhone, {}, true);
      }
      else {
        this.otpConfirmationResult = await this.firebaseService.loginWithPhone(intlPhone, this.windowRef.recaptchaVerifier, false);
      }
    } catch (error) {
      console.error('error during loginWithPhone:', error);
    } finally {
      if (!!this.otpConfirmationResult) {
      this.stepper.selectedIndex = this.steps['submitOtp'];
      }
      // Todo: Tim: Should display a user error if OTP confirm result is not returned. Possibly reset OTP Form
    }
  }

  public async resendOtp(): Promise<void> {
    try {
      if (this.isRegressionEnv || !this.isFirebaseEnabled) {
        console.log('in resendOtp... triggering login again MOCK'); // Todo: remove:
        this.otpConfirmationResult = await this.firebaseService.loginWithPhone(this.userInternationPhoneNumber, {}, true);
      }
      else {
        console.log('in resendOtp... triggering login again'); // Todo: remove:
        this.otpConfirmationResult = await this.firebaseService.loginWithPhone(this.userInternationPhoneNumber, this.windowRef.recaptchaVerifier, false);
      }
    } catch (error) {
      console.error('error during resendOtp:', error);
      this.errorService.open(this.cmsLabels.stellar.error.somethingHasGoneWrong, this.cmsLabels.stellar.dismiss); // Todo: #CMS
    }
  }

  public async verifyOtp(otp: string) {
    // console.log('%c in verifyOtp. User entered OTP is:', 'color:green', otp); // Todo: remove:
    if (!otp) {
      console.error('otp is null/invalid');
    }
    // Todo: Tim: Re-enable when we are ready to have QA test firebase and SAS API integration
    try { // Todo: Tim: should refactor into the firebase.service
      const otpResult = await this.otpConfirmationResult.confirm(otp);
      this.userAuthToken = await this.auth.currentUser?.getIdToken() ?? 'notoken'; // Todo: tim: 
      console.log('%c in this.verifyOtp. otpResult', 'color:lightskyblue', otpResult); // Todo: remove:
      console.log('setting this.userAuthToken to:', this.userAuthToken); // TOdo: remove:
      if (this.flow === 'register') {
        this.stepper.selectedIndex = this.steps['registerEmail'];
      }
      else if (this.flow === 'login') {
        this.navigateToTransactionFlow();
      }
    } catch (error) {
      console.error('error during verifyOtp:', error);
      this.errorService.open(this.cmsLabels.stellar.error.somethingHasGoneWrong, this.cmsLabels.stellar.dismiss); // Todo: #CMS
    }
  }

  public handleSubmitEmailEvent(emailAddress: string): void {
    // public async handleSubmitEmailEvent(emailAddress: string): Promise<void> {
    // console.log('handleSubmitEmailEvent...', emailAddress); // Todo: remove:
    // if (this.flow === 'login') {
    //   let isValidEmail: boolean;
    //   try {
    //     const response = await this.signInService.validateEmail(this.userPhoneNumber, this.userDialCode, emailAddress, this.userAuthToken);
    //     isValidEmail = response.valid ?? false;
    //     if (isValidEmail) {
    //       this.navigateToTransactionFlow();
    //     }
    //     else {
    //       this.errorService.open('_This email address does not match the email associated with your account.', this.cmsLabels.stellar.dismiss); // Todo: Tim: #CMS
    //       this.registerEmailComponent.resetEmailForm();
    //     }
    //   } catch (error) {
    //     console.error('error during validateEmail - validateEmail', error);
    //     this.errorService.open(this.cmsLabels.stellar.error.somethingHasGoneWrong, this.cmsLabels.stellar.dismiss); // Todo: #CMS
    //   }
    // }
    // else if (this.flow === 'register') {
      this.userEmail = emailAddress;
      this.stepper.selectedIndex = this.steps['userProfile'];
    // }
  }

  private resetAllChildForms() {
    this.requestOtpComponent.resetPhoneForm();
    this.submitOtpComponent.resetOtpForm();
    this.registerEmailComponent.resetEmailForm();
  }

  handleBackButton(): void {
    // Todo: Tim: Revisit this. May want to find a different way to setup the steps so that we don't have to have a bunch of conditional logic for things like the back button.
    if (this.flow === 'login' && this.stepper.selectedIndex === this.steps['submitOtp']) {
      this.stepper.selectedIndex = 0;
    }
    else {
      this.stepper.selectedIndex = this.stepper.selectedIndex > 0 ? this.stepper.selectedIndex - 1 : 0;
    }

    // Todo: tim: should the form be reset? And should the user be logged out? (if they were logged in)
    if (this.stepper.selectedIndex === 0) {
      this.flow = null;
      this.resetAllChildForms();
    }
  }

  public displayBackButton() {
    if (!this.stepper || !this.stepper.selectedIndex) return false;
    return this.stepper.selectedIndex > 0;
  }

  // Todo: decodeJWT and isClientNameInJWT are pure functions, used in both home.ts and sign-in.ts. These can be refactored into a utils file. 
  public decodeJWT(token: string): DecodedJWT {
    const arrayToken = token.split('.');
    const decodedToken = JSON.parse(atob(arrayToken[1]));
    return decodedToken;
  }

  public isClientNameInJWT(token: string): boolean {
    const decodedToken = this.decodeJWT(token);
    return !!decodedToken['client_name'];
  }

  private getWalletIDFromJWT(token: string): string {
    const decodedToken: DecodedJWT = this.decodeJWT(token);
    const walletId: string = decodedToken.sub;
    return walletId;
  }
  
  public async onNotifyUserRegistration(userProfile: UserRegistration): Promise<void> {
    console.log('userRegistration submitted value', userProfile)
    try {
      const response = await this.signInService.registerNewProfile(userProfile, this.userWalletId, this.userEmail, this.userPhoneNumber, this.userDialCode, this.userAuthToken);
      console.log('onNotifyUserRegistration - this.signInService.registerNewProfile - response', response)
      this.navigateToTransactionFlow();
    } catch (error) {
      console.error('error during onNotifyUserRegistration', error);
      this.errorService.open(this.cmsLabels.stellar.error.somethingHasGoneWrong, this.cmsLabels.stellar.dismiss); // Todo: #CMS
    }
  }
}
